console.log('From faqs component!!!');